import { render, staticRenderFns } from "./addstoredetail.vue?vue&type=template&id=4cb006b4&scoped=true&"
import script from "./addstoredetail.vue?vue&type=script&lang=js&"
export * from "./addstoredetail.vue?vue&type=script&lang=js&"
import style0 from "./addstoredetail.vue?vue&type=style&index=0&id=4cb006b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb006b4",
  null
  
)

export default component.exports